import {Component} from '@angular/core';
import {IonicPage, NavController, NavParams, Platform, ViewController} from 'ionic-angular';
import {ServiceProvider} from "../../providers/service/service";
import {DatePipe} from "@angular/common";


@Component({
    selector: 'page-predata-call-logs',
    templateUrl: 'predata-call-logs.html',
})
export class PredataCallLogsPage {

    LogsData=[];

    constructor(public navCtrl: NavController, public navParams: NavParams, public datepipe:DatePipe,
                public service: ServiceProvider,
                public platform: Platform,
                public viewCtrl: ViewController) {
        this.platform.ready().then(() => {
                this.LogsData = navParams.get('data');
                console.log("LogsData->",this.LogsData);
        })
    }


    ionViewDidLoad() {
        console.log('ionViewDidLoad PredataCallLogsPage');
    }

    dismiss() {
        this.viewCtrl.dismiss();
    }
}



// WEBPACK FOOTER //
// ./src/pages/predata-call-logs/predata-call-logs.ts